export type FrontAppearance = 'classic';

export const FRONT_APPEARANCE_STORAGE_KEY = 'becoder:front-v2-appearance';

export function isFrontAppearance(value: unknown): value is FrontAppearance {
  return value === 'classic';
}

export function readFrontAppearance(): FrontAppearance {
  return 'classic';
}

export function applyFrontAppearance(_appearance: FrontAppearance = 'classic', root: HTMLElement = document.documentElement) {
  root.dataset.frontTheme = 'classic';
}

export function saveFrontAppearance(_appearance: FrontAppearance = 'classic') {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(FRONT_APPEARANCE_STORAGE_KEY, 'classic');
  } catch (e) {
    // Appearance preference is best-effort.
  }
}
